import {
  Holder,
  Pic,
  Overlay,
  Caption,
  Text,
  QuoteText,
  Pivot,
  PicHolder,
  TopQ,
  BottomQ,
  TitleHolder,
  Title,
  SubTitle
} from "./VisionariesSlide3.style"

import TopQIcon from "./top_quote.svg"
import BottomQIcon from "./bottom_quote.svg"

export default function VisionariesSlide3() {
  return (
    <Holder>
      <Pivot>
        <PicHolder>
          <Pic src="/assets/images/about/architects/2.jpg" />
          <TitleHolder>
            <Title>Wish.</Title>
            <SubTitle>Interior Designers</SubTitle>
          </TitleHolder>
          <Overlay>
            <Caption>
              <TopQ src={TopQIcon} alt="" />
              <QuoteText>
                 Dotting the i’s and
                <br />
                crossing the t’s is at the
                <br />
                core of the
                <br />
                WISH philosophy.
              </QuoteText>
              <BottomQ src={BottomQIcon} alt="" />
              <Text>
                WISH London is an Interior Architecture and Design Company with a wealth of
                experience in the high-end residential, commercial and hospitality sectors. We are
                thorough and meticulous and deliver unique, innovative and elegant spaces which
                is key to our success.
              </Text>
              <Text>
                Free from a ‘house style’ means we can evaluate each project on its own individual
                merit. Our design approach is to create exciting, relevant and noteable
                interiors. Our layered approach allows us to review each stage of a project from
                feasibility, sensitive and intelligent space planning through to meticulous
                detailing and quality control. We are presently leading a number of large
                residential projects in Belgravia, a Private Members Club in Mayfair and are on the
                preferred partners list with Hilton Hotels and Marriott Hotels.
              </Text>
            </Caption>
          </Overlay>
        </PicHolder>
      </Pivot>
    </Holder>
  )
}
